<script>
  import { onMount } from 'svelte';
  import { tools } from './constants.js';

  export let skip = '';
  let showTools = {};

  onMount(() => {
    showTools = {...tools};
    if (skip != '') {
      if (showTools[skip] != undefined) {
        delete showTools[skip];
      }
    }
  });
</script>

<!-- <section class="section row tool-card mb-5">
  <div class="container">
    <div class="intro-block">
      <div class="row row-cols-1 row-cols-md-3 g-4">
        {#each Object.entries(showTools) as [key, tool]}
        <div class="col">
          <div class="card">
            <span class="top-border bg-light-grey"></span>
            <div class="card-body">
              <h6 class="card-title font-weight-bold">{tool.title}</h6>
              <p class="card-text">{tool.text}.</p>
              <a href="{tool.link}" class="link purple-arrow" title="{tool.linkTitle}">{tool.linkText}</a>
            </div>
          </div>
        </div>
        {/each}
      </div>
    </div>
  </div>
</section> -->

<style>

</style>
